"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9569],{

/***/ 9569:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ Tabs; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ../wif-ui-lib/dist/app-a75c1d35.mjs
var app_a75c1d35 = __webpack_require__(3406);
// EXTERNAL MODULE: ../wif-ui-lib/dist/Block-9b78bd10.mjs
var Block_9b78bd10 = __webpack_require__(4877);
;// CONCATENATED MODULE: ../wif-ui-lib/dist/Tabs.js



const C = "tabs__sub-heading", L = "desktop", _ = "tabs__list", g = "tabs__content", I = "tabs__listItem", k = "tabs__listItem--current", n = {
  tabsSubHeading: C,
  desktop: L,
  tabsList: _,
  tabsContent: g,
  tabsListItem: I,
  tabsListItemCurrent: k
};
function y(o) {
  const { tabData: e, sectionHeading: b } = o, [a, d] = (0,react.useState)(e[0].uid), m = (t) => {
    d(t);
  }, r = (0,react.useMemo)(
    () => e.find((t) => a == t.uid)?.content ?? null,
    [a, e]
  );
  return /* @__PURE__ */ react.createElement(
    Block_9b78bd10.B,
    {
      topPadding: Block_9b78bd10.B.Padding.SMALL,
      bottomPadding: Block_9b78bd10.B.Padding.LARGE,
      "data-testid": "tabs-block"
    },
    /* @__PURE__ */ react.createElement(
      Block_9b78bd10.B.Content,
      {
        className: (0,app_a75c1d35.c)(n.tabsContent),
        "data-testid": "tabs-content"
      },
      /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(n.tabsSubHeading, app_a75c1d35.t.headingSection) }, b),
      /* @__PURE__ */ react.createElement("div", { className: (0,app_a75c1d35.c)(n.tabsList), "data-testid": "tabs-list" }, e.map((t) => /* @__PURE__ */ react.createElement(
        f,
        {
          key: t.uid + t.tabTitle,
          ...t,
          onClick: m,
          activeTabId: a,
          "data-testid": "tabs"
        }
      ))),
      r
    )
  );
}
function f({
  uid: o,
  tabTitle: e,
  activeTabId: b,
  onClick: a
}) {
  const d = (0,app_a75c1d35.c)(
    n.tabsListItem,
    o === b && n.tabsListItemCurrent,
    app_a75c1d35.t.textsComponentTitleBold
  );
  return /* @__PURE__ */ react.createElement("button", { type: "button", className: d, onClick: () => a(o) }, e);
}

//# sourceMappingURL=Tabs.js.map

// EXTERNAL MODULE: ../wif-ui-lib/dist/PromotionBanner.js
var PromotionBanner = __webpack_require__(2617);
// EXTERNAL MODULE: ./src/constants/app.ts
var app = __webpack_require__(5884);
// EXTERNAL MODULE: ./src/hooks/useImageDataHandler.ts
var useImageDataHandler = __webpack_require__(4847);
;// CONCATENATED MODULE: ./src/magnolia/components/Tabs/Tabs.tsx







function Tabs(param) {
    var sectionHeading = param.sectionHeading, banners = param.banners;
    var imageDataHandler = (0,useImageDataHandler/* default */.Z)();
    if (!banners || banners.length === 0) return null;
    var tabs = banners.map(function(banner) {
        return createTabFromBanner(banner, imageDataHandler);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(y, {
        sectionHeading: sectionHeading,
        tabData: tabs
    });
}
function createTabFromBanner(banner, imageDataHandler) {
    var ref, ref1;
    var imageData = imageDataHandler(banner.image, {
        maxViewport: app/* Viewport.sm */.l_.sm
    });
    var imageAlt = banner.imageAlt || typeof banner.image === "object" && ((ref = banner.image) === null || ref === void 0 ? void 0 : (ref1 = ref.metadata) === null || ref1 === void 0 ? void 0 : ref1.title) || "Promotion banner image";
    return {
        tabTitle: banner.tabTitle,
        uid: banner.id,
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionBanner/* PromotionBanner */.v, {
            imageData: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, imageData), {
                imageSrc: imageData.src
            }),
            direction: banner.direction,
            showSaveButton: false,
            body: banner.tabLeadText,
            link: banner.link,
            btnText: banner.btnText,
            imageAlt: imageAlt,
            promotionType: "default",
            removeMargin: true,
            isExternalLink: banner.isExternalLink,
            credits: banner.credits
        }, banner.id)
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/Tabs/index.ts
/* istanbul ignore file */ 


/***/ }),

/***/ 2617:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ To; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3406);
/* harmony import */ var _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4877);
/* harmony import */ var _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5905);
/* harmony import */ var _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(965);
/* harmony import */ var _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7977);
/* harmony import */ var _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3355);
/* harmony import */ var _useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(8643);











const P = "promotion", N = "promotion__background--gray", k = "promotion__lead_text", D = "promotion__save-left-button", L = "promotion__save-left-button__hidden", S = "promotion__save-right-button", C = "desktop", O = "promotion__header_text", H = "promotion__header_text--inverse", R = "promotion__body_text", W = "promotion__body_text--gray-bg", G = "promotion__button", w = "promotion__container", M = "promotion__svg__desktop", z = "promotion__svg__SmallTablet", A = "promotion__svg__LargeTablet", F = "promotion__svg__mobile", V = "promotion__svg__close", U = "promotion__image", j = "promotion__infos", q = "promotion__default-image", J = "promotion__default-container", K = "promotion__default-container-without-margin", Q = "promotion__default-left-image", X = "promotion__default-infos-background", Y = "promotion__default-infos-background--white", Z = "promotion__default-infos-background--dark-blue", $ = "promotion__default-infos", oo = "promotion__default-infos__description", to = "promotion__default-left-infos", eo = "promotion__default-left-infos__description", no = "promotion__campaign--vertical", ro = "promotion__campaign--horizontal", t = {
  promotion: P,
  promotionBackgroundGray: N,
  promotionLeadText: k,
  promotionSaveLeftButton: D,
  promotionSaveLeftButtonHidden: L,
  promotionSaveRightButton: S,
  desktop: C,
  promotionHeaderText: O,
  promotionHeaderTextInverse: H,
  promotionBodyText: R,
  promotionBodyTextGrayBg: W,
  promotionButton: G,
  promotionContainer: w,
  promotionSvgDesktop: M,
  promotionSvgSmallTablet: z,
  promotionSvgLargeTablet: A,
  promotionSvgMobile: F,
  promotionSvgClose: V,
  promotionImage: U,
  promotionInfos: j,
  promotionDefaultImage: q,
  promotionDefaultContainer: J,
  promotionDefaultContainerWithoutMargin: K,
  promotionDefaultLeftImage: Q,
  promotionDefaultInfosBackground: X,
  promotionDefaultInfosBackgroundWhite: Y,
  promotionDefaultInfosBackgroundDarkBlue: Z,
  promotionDefaultInfos: $,
  promotionDefaultInfosDescription: oo,
  promotionDefaultLeftInfos: to,
  promotionDefaultLeftInfosDescription: eo,
  promotionCampaignVertical: no,
  promotionCampaignHorizontal: ro
};
function io({
  leadText: r,
  heading: p,
  body: g,
  imageAlt: u,
  imageData: i,
  link: f,
  linkLocale: l,
  isExternalLink: s = !1,
  btnText: m,
  credits: c
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      className: t.promotionCampaignVertical,
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      "data-testid": "promotion-banner-vertical"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.promotionImage),
        "data-testid": "promotion-banner-image"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
        {
          credits: c,
          src: i.imageSrc,
          width: i.width,
          height: i.height,
          altText: u || "Promotion banner image",
          imageLoader: i.imageLoader,
          styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.PROMOTION
        }
      )
    ),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content,
      {
        className: t.promotionInfos,
        "data-testid": "promotion-banner-content",
        itemScope: !0,
        itemType: "https://schema.org/Thing",
        flex: !0
      },
      !!r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "p",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold,
            t.promotionLeadText
          ),
          itemProp: "description"
        },
        r
      ),
      !!p && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "h3",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold,
            t.promotionHeaderText
          ),
          itemProp: "name"
        },
        p
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.richText,
            _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText,
            t.promotionBodyText
          ),
          itemProp: "description"
        },
        g
      ),
      m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: t.promotionButton,
          "data-testid": "promotion-banner-action"
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
          {
            className: _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.PrimaryFocusStyleInLink,
            href: f,
            locale: l,
            target: s ? "_blank" : void 0,
            disableLinkTextStyle: !0,
            itemProp: "url"
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Primary,
            {
              text: m,
              icon: s ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_6__.W.ARROW_UP_RIGHT : void 0,
              asDiv: !0,
              preventEmployerStyle: !0
            }
          )
        )
      )
    )
  );
}
function ao({
  leadText: r,
  heading: p,
  body: g,
  imageAlt: u,
  imageData: i,
  link: f,
  linkLocale: l,
  isExternalLink: s = !1,
  btnText: m,
  credits: c
}) {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      className: t.promotionCampaignHorizontal,
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      bottomPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      "data-testid": "promotion-banner-horizontal"
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content,
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.promotionContainer),
        "data-testid": "promotion-banner-container",
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.promotionImage),
          "data-testid": "promotion-banner-image"
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
          {
            credits: c,
            src: i.imageSrc,
            width: i.width,
            height: i.height,
            altText: u || "Promotion banner image",
            imageLoader: i.imageLoader,
            styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.PROMOTION
          }
        )
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.promotionInfos),
          "data-testid": "promotion-banner-content"
        },
        !!r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "p",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold,
              t.promotionLeadText
            ),
            itemProp: "description"
          },
          r
        ),
        !!p && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "h3",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold,
              t.promotionHeaderText
            ),
            itemProp: "name"
          },
          p
        ),
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "div",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.richText,
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText,
              t.promotionBodyText
            ),
            itemProp: "description"
          },
          g
        ),
        m && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "div",
          {
            className: t.promotionButton,
            "data-testid": "promotion-banner-action"
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
            {
              className: _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.PrimaryFocusStyleInLink,
              href: f,
              locale: l,
              target: s ? "_blank" : void 0,
              disableLinkTextStyle: !0,
              itemProp: "url"
            },
            /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
              _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Primary,
              {
                text: m,
                icon: s ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_6__.W.ARROW_UP_RIGHT : void 0,
                asDiv: !0,
                preventEmployerStyle: !0
              }
            )
          )
        )
      )
    )
  );
}
function mo(r) {
  const {
    heading: p,
    body: g,
    imageAlt: u,
    link: i,
    linkLocale: f,
    btnText: l,
    isExternalLink: s,
    direction: m,
    removeMargin: c,
    imageData: v,
    backgroundColor: _ = "white",
    credits: x
  } = r, h = (0,_useClickOutside_726e7c36_mjs__WEBPACK_IMPORTED_MODULE_7__.u)(), b = (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)({
    [t.promotionDefaultInfos]: m === "right",
    [t.promotionDefaultLeftInfos]: m !== "right",
    [t.promotionDefaultInfosBackground]: !h,
    [t.promotionDefaultInfosBackgroundWhite]: h && _ === "gray",
    [t.promotionDefaultInfosBackgroundDarkBlue]: h && _ !== "gray"
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      topPadding: _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE,
      bottomPadding: c ? _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.NONE : _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.LARGE,
      className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
        t.promotion,
        h && _ === "gray" && t.promotionBackgroundGray
      )
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      _Block_9b78bd10_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content,
      {
        className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          c ? t.promotionDefaultContainerWithoutMargin : t.promotionDefaultContainer
        ),
        itemScope: !0,
        itemType: "https://schema.org/Thing"
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
            m === "right" ? t.promotionDefaultImage : t.promotionDefaultLeftImage
          ),
          "data-testid": "promotion-banner-image-container"
        },
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.I,
          {
            credits: x,
            src: v.imageSrc,
            width: v.width,
            height: v.height,
            altText: u || "Promotion banner image",
            imageLoader: v.imageLoader,
            styling: _Image_d6406817_mjs__WEBPACK_IMPORTED_MODULE_3__.a.PROMOTION
          }
        )
      ),
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
        "div",
        {
          "data-testid": "promotion-banner-content",
          className: b
        },
        p && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "h3",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold,
              t.promotionHeaderText,
              h && _ !== "gray" && t.promotionHeaderTextInverse
            ),
            itemProp: "name"
          },
          p
        ),
        /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "div",
          {
            className: (0,_app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.richText,
              _app_a75c1d35_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsLeadText,
              t.promotionBodyText,
              [_ === "gray" ? "" : t.promotionBodyTextGrayBg]
            ),
            itemProp: "description"
          },
          g
        ),
        l && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
          "div",
          {
            className: t.promotionButton,
            "data-testid": "promotion-banner-action"
          },
          /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
            _Link_479ac100_mjs__WEBPACK_IMPORTED_MODULE_4__.L,
            {
              className: _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.PrimaryFocusStyleInLink,
              href: i,
              target: s ? "_blank" : void 0,
              locale: f,
              disableLinkTextStyle: !0,
              itemProp: "url"
            },
            /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
              _Button_c598cb52_mjs__WEBPACK_IMPORTED_MODULE_5__.B.Primary,
              {
                text: l,
                icon: s ? _Icon_3122c134_mjs__WEBPACK_IMPORTED_MODULE_6__.W.ARROW_UP_RIGHT : void 0,
                asDiv: !0
              }
            )
          )
        )
      )
    )
  );
}
function To(r) {
  return r.promotionType === "campaign" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ao, { ...r }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(io, { ...r })) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(mo, { ...r });
}

//# sourceMappingURL=PromotionBanner.js.map


/***/ })

}]);